import React from 'react';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { allsvg } from '../../utils/allsvg.js';
import { routes } from '../../routing/routes';

export const OldFooter = () => {
  return (
    <footer>
      <div className="container py-5">
        <div className="row">
          <div className="col-6 col-lg-3 mb-4">
            <ul className="nav flex-column">
              <li className="nav-item">
                <strong>About</strong>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.roadmap()}>
                  Roadmap
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.news.base()}>
                  News
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.team()}>
                  Team
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" target="_new" href="https://jobs.lever.co/Metatheory/">
                  Careers
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.provenance()}>
                  Provenance
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.help()}>
                  Help
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-lg-3 mb-4">
            <ul className="nav flex-column">
              <li className="nav-item">
                <strong>World</strong>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.gallery.base()}>
                  Breaker Gallery
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.lore.base()}>
                  Lore
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.media()}>
                  Media
                </Link>
              </li>
              <li className="nav-item">
                <strong>Legal</strong>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.terms()}>
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-lg-3 mb-4">
            <ul className="nav flex-column">
              <li className="nav-item">
                <strong>Community</strong>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://discord.gg/duskbreakers" target="_new">
                  <SVG className="ui-icon faded" src={allsvg.discord_icon} />
                  <span>Discord</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://twitter.com/duskbreakers" target="_new">
                  <SVG className="ui-icon faded" src={allsvg.twitter_icon} />
                  <span>Twitter</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://opensea.io/collection/duskbreakers"
                  target="_new"
                >
                  <SVG className="ui-icon faded" src={allsvg.opensea_icon} />
                  <span>OpenSea</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://www.instagram.com/DuskBreakersNFT/"
                  target="_new"
                >
                  <SVG className="ui-icon faded" src={allsvg.instagram_icon} />
                  <span>Instagram</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://www.youtube.com/channel/UCnAWj3_CYl30cga1k5fzG9g"
                  target="_new"
                >
                  <SVG className="ui-icon faded" src={allsvg.youtube_icon} />
                  <span>Youtube</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.twitch.tv/duskbreakers" target="_new">
                  <SVG className="ui-icon faded" src={allsvg.twitch_icon} />
                  <span>Twitch</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.tiktok.com/@duskbreakers" target="_new">
                  <SVG className="ui-icon faded" src={allsvg.tiktok_icon} />
                  <span>TikTok</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-lg-3 mb-4">
            <ul className="nav flex-column">
              <li className="nav-item">
                <Link className="nav-link" to={routes.launcher()}>
                  Download Launcher
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={routes.duskAccount.base()}>
                  Account
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <span id="footer-logo" className="me-2">
              <SVG src={allsvg.circlelogo} />
            </span>
            <span className="text-small text-muted">DuskBreakers © Metatheory 2022</span>
          </div>
        </div>
      </div>

      <a id="back-to-top" href="#top">
        <span className="visually-hidden">Back to top</span>
        <SVG src={allsvg.arrow_up_icon} />
      </a>
      <hr className="hazard" />
    </footer>
  );
};
